import { CalendarCheck2, Construction, UsersRound } from "lucide-react";
import type { MobileRole } from "../../lib/access";
import type { AppTabId } from "../../lib/navigation";

interface PlaceholderTabProps {
  readonly role: MobileRole;
  readonly tab: Extract<AppTabId, "activity">;
}

const COPY = {
  member: {
    activity: {
      icon: CalendarCheck2,
      title: "Reservas",
      description: "Suas reservas de quadra e o histórico de treinos ficarão organizados nesta aba.",
      bullets: ["Próximas reservas", "Histórico de treinos", "Cancelamento com motivo"],
    },
  },
  coach: {
    activity: {
      icon: UsersRound,
      title: "Turmas",
      description: "Suas turmas, alunos matriculados e chamadas ficarão reunidos nesta aba.",
      bullets: ["Turmas do professor", "Lista de alunos", "Check-in da aula"],
    },
  },
} as const;

export function PlaceholderTab({ role, tab }: PlaceholderTabProps) {
  const content = COPY[role][tab];
  const Icon = content.icon;

  return (
    <div className="tab-page">
      <section className="placeholder">
        <span className="placeholder__icon"><Icon size={28} aria-hidden="true" /></span>
        <span className="chip">Em construção</span>
        <h1 className="placeholder__title">{content.title}</h1>
        <p className="placeholder__description">{content.description}</p>
        <ul className="placeholder__list">
          {content.bullets.map(item => (
            <li key={item}>
              <Construction size={15} aria-hidden="true" />
              {item}
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
}
